export default __webpack_public_path__ + "static/loadingIcon-803f24369a085e35482e874050e62261.gif";